import { Store, StoreServiceSite, OpeningHours } from '../hooks/types'

export const mapSitesToStores = (stores: StoreServiceSite[]): Store[] =>
  stores.map((site) => {
    const addressAttr = site.attributes.find(
      (attr) => attr.attributeId === 'address',
    )
    const coordsAttr = site.attributes.find(
      (attr) => attr.attributeId === 'coordinates',
    )
    const displayNameAttr = site.attributes.find(
      (attr) => attr.attributeId === 'display_name',
    )

    // const edynamixAttr = site.attributes.some(
    //   (attr) => attr.attributeId === 'edynamix-integrated',
    // )

    const dealerIdAttr = site.attributes.find(
      (attr) => attr.attributeId === 'dealer-id',
    )

    const openingHoursAttr = site.attributes.find(
      (attr) => attr.attributeId === 'opening_hours',
    )

    const addressValue = addressAttr?.attributeValue as {
      addressLine1: string
      city: string
      county: string
      postcode: string
    }
    const coordsValue = coordsAttr?.attributeValue as {
      latitude: number
      longitude: number
    }

    let openingHours: OpeningHours | undefined
    if (openingHoursAttr?.attributeValue) {
      try {
        const hoursArray = openingHoursAttr.attributeValue as Array<{
          department: string
          monday?: { start: string; end: string }
          tuesday?: { start: string; end: string }
          wednesday?: { start: string; end: string }
          thursday?: { start: string; end: string }
          friday?: { start: string; end: string }
          saturday?: { start: string; end: string }
          sunday?: { start: string; end: string }
        }>

        const serviceHours = hoursArray.find(
          (hours) => hours.department === 'Service',
        )

        if (serviceHours) {
          openingHours = {
            monday: serviceHours.monday || { start: 'Closed', end: 'Closed' },
            tuesday: serviceHours.tuesday || { start: 'Closed', end: 'Closed' },
            wednesday: serviceHours.wednesday || {
              start: 'Closed',
              end: 'Closed',
            },
            thursday: serviceHours.thursday || {
              start: 'Closed',
              end: 'Closed',
            },
            friday: serviceHours.friday || { start: 'Closed', end: 'Closed' },
            saturday: serviceHours.saturday || {
              start: 'Closed',
              end: 'Closed',
            },
            sunday: serviceHours.sunday || { start: 'Closed', end: 'Closed' },
          }
        }
      } catch (error) {
        console.error(
          'Error parsing opening hours for',
          site.siteId,
          ':',
          error,
        )
      }
    }

    return {
      id: site.siteId,
      name: displayNameAttr?.attributeValue as string,
      addressLine1: addressValue?.addressLine1 || '',
      town: addressValue.city,
      county: addressValue.county,
      postcode: addressValue.postcode,
      coordinates: coordsValue,
      //TODO: Switch to using edynamixAttr to turn on workshop+ booking
      // canBookAppointment: edynamixAttr,
      canBookAppointment: false,
      dealerId: (dealerIdAttr?.attributeValue as string) || '',
      openingHours,
    }
  })
